import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ViewKpiMachineContainer from '../../../modules/machinekpi/containers/view.kpi.machine.container';
import SelectGraphViewKpiMachineContainer from '../../../modules/machinekpi/containers/select.graph.view.kpi.machine.container';
import useHttpApiCall from '../../../services/useHttpApiCall';

function KpiMachineLayoutComponent(props) {
  const [payload, setPayload] = useState(null);
  const [data] = useHttpApiCall(payload);
  const [kpiMachineStatus, setKpiMachineStatus] = useState(null);
  const [idParams, setIdParams] = useState(null);
  const [currentKpiId, setCurrentKpiId] = useState(null);
  const [viewKpiList, setViewKpiList] = useState([]);
  const [isAllKpiSet, setIsAllKpiSet] = useState(false);
  const [updateState, setUpdateState] = useState(false);
  const [currentKpiStatus, setCurrentKpiStatus] = useState(null);
  const [showKpiBox, setShowKpiBox] = useState(true);
// console.log('Received props param:', idParams); // Debug line
  
  // Temporary safety check
  if (!props.processDetails) {
    console.error('Missing processDetails! Full props:', props);
    return <div>Configuration error: Missing processDetails</div>;
  }
  const location = useLocation();
  useEffect(() => {
    let apiParams;
      if (props.processDetails.drilldownlevel == 'Process') {
      apiParams = {
        process_id: props.processDetails.process_id,
        sub_process_id: props.processDetails.sub_process_id,
        layer_type: props.processDetails.layer_type,
        layer_id: props.processDetails.layer_id,
        kpi_id: props.processDetails.kpi_id,
        kpi_unit:props.processDetails.kpi_unit,
        plant_code:props.processDetails.plant_code,
        
      };
    }
    else if (props.processDetails.drilldownlevel == 'selectGraphLayer') {
      apiParams = {
        process_id: props.processDetails.process_id,
        sub_process_id: props.processDetails.sub_process_id,
        layer_type: props.processDetails.layer_type,
        layer_id: props.processDetails.layer_id,
        kpi_id: props.processDetails.kpi_id,
        kpi_unit:props.processDetails.kpi_unit,
        plant_code:props.processDetails.plant_code,
        selectedGraphNames:props.processDetails.selectedGraphNames,
        graphType:props.processDetails.graph_type,
        isNewDashboard: true ,
        graph_name: props.processDetails.graph_name

      };
    }
    else if (props.processDetails.drilldownlevel=='ProcessLayer') {
      console.log("PL",props.processDetails.process_type);
    
      apiParams = {
        layer_id: props.processDetails.process_id|| props.processDetails.layer_id ,
        plant_code:props.processDetails.plant_code,
        // sub_process_id: props.processDetails.sub_process_id,
        layer_type:props.processDetails.process_type||props.processDetails.layer_type,
        kpi_id: props.processDetails.kpi_id,
        kpi_unit:props.processDetails.kpi_unit,
        
      }
    }
    else if (props.processDetails.drilldownlevel=='EquipmentLayer') {
      apiParams = {
        layer_id: props.processDetails.process_id || props.processDetails.layer_id ,
        plant_code:props.processDetails.plant_code,
        // sub_process_id: props.processDetails.sub_process_id,
        layer_type:props.processDetails.process_type ||"equipment"|| props.processDetails.layer_type,
      };
      console.log("EL",apiParams.layer_type);
    } 
    else if (props.processDetails.drilldownlevel=='ComponentLayer') {
      apiParams = {
        layer_id: props.processDetails.process_id||props.processDetails.layer_id,
        plant_code:props.processDetails.plant_code,
        // sub_process_id: props.processDetails.sub_process_id,
        layer_type:props.processDetails.process_type|| props.processDetails.layer_type,
        kpi_id: props.processDetails.kpi_id,
        kpi_unit:props.processDetails.kpi_unit,
      };
      console.log("CL",props.processDetails.process_type);
    }
    else {
      apiParams = {
        process_id: props.processDetails.process_id||props.processDetails.layer_id,
        sub_process_id: props.processDetails.sub_process_id,
        equipment_id: props.processDetails.equipment_id,
        layer_id: props.processDetails.layer_id,
        layer_type:props.processDetails.process_type||props.processDetails.layer_type,
        kpi_id: props.processDetails.kpi_id,
        kpi_unit:props.processDetails.kpi_unit,
        plant_code:props.processDetails.plant_code
      };
    }
    setIdParams(apiParams);
    setPayload({
      auth: true,
      url: 'v0/equipments/kpis/enabled-status/',
      params: apiParams
    });
  }, [location.pathname, updateState]);

  useEffect(() => {
    if (data && data.data) {
      setKpiMachineStatus(data.data.data.is_kpi_enabled);
      setIsAllKpiSet(data.data.data.is_all_kpi_set);
      setCurrentKpiStatus(data.data.data);
      setShowKpiBox(!data.data.data.is_kpi_eye_hidden);
    }
  }, [data]);

 const renderContainer = () => {
    if (props.processDetails.drilldownlevel === 'selectGraphLayer') {
      return (
        <SelectGraphViewKpiMachineContainer
          showKpiBox={showKpiBox}
          setShowKpiBox={setShowKpiBox}
          setUpdateState={setUpdateState}
          updateState={updateState}
          setViewKpiList={setViewKpiList}
          viewKpiList={viewKpiList}
          kpiMachineStatus={kpiMachineStatus}
          idParams={idParams}
          setKpiMachineStatus={setKpiMachineStatus}
          currentKpiId={currentKpiId}
          setCurrentKpiId={setCurrentKpiId}
          isAllKpiSet={isAllKpiSet}
          currentKpiStatus={currentKpiStatus}
          setCurrentKpiStatus={setCurrentKpiStatus}
          selectedGraphNames={props.selectedGraphNames}
        />
      );
    } else {
      return (
        <ViewKpiMachineContainer
          showKpiBox={showKpiBox}
          setShowKpiBox={setShowKpiBox}
          setUpdateState={setUpdateState}
          updateState={updateState}
          setViewKpiList={setViewKpiList}
          viewKpiList={viewKpiList}
          kpiMachineStatus={kpiMachineStatus}
          idParams={idParams}
          setKpiMachineStatus={setKpiMachineStatus}
          currentKpiId={currentKpiId}
          setCurrentKpiId={setCurrentKpiId}
          isAllKpiSet={isAllKpiSet}
          currentKpiStatus={currentKpiStatus}
          setCurrentKpiStatus={setCurrentKpiStatus}
          selectedGraphNames={props.selectedGraphNames}
        />
      );
    }
  };

  return (
    <div>
      {renderContainer()}
    </div>
  );
}

export default KpiMachineLayoutComponent;
